import React from 'react';

class NodeWithoutChildren extends React.Component {
  render() {
    return <img className="node-without-children" src="/assets/hnav/dot.png" />;
  }
}

export default NodeWithoutChildren;
